<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-book-open-variant" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Saneamento do Razão</div>
      </template>
      <v-btn
        id="btn-novo"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="novos"
      >
        <v-icon left size="30px">mdi-cloud-refresh-variant</v-icon>
        Verificar Novos Arquivos
      </v-btn>
      <v-text-field
        id="historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-laudos-incrementais ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />

      <general-progress-bars
        class="mt-11"
        :items="downloadProgressData"
        prefix-text="Baixando o resultado do Saneamento do Razão"
      />

      <v-divider class="mt-10" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhum saneamento do razão disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.sort_versao`]="{ item }">
          {{ item.mes.toString().padStart(2, '0') }}/{{ item.ano.toString().padStart(4, '0') }} ({{ item.versao }})
        </template>
        <template v-slot:[`item.finished_at`]="{ item }">
          {{ item.finished_at | parseToDateTimeBR }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.problemas`]="{ item }">
          <span v-if="item.status === 'SUCESSO'" class="align-center d-flex">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="align-center d-flex mr-3" v-bind="attrs" v-on="on">
                  <v-icon small color="error">mdi-alert-circle</v-icon>
                  <span class="caption ml-1">{{ item.num_erros | parseNumberToIntegerBR }}</span>
                </span>
              </template>
              <span>{{ item.num_erros | parseNumberToIntegerBR }} erro(s)</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="align-center d-flex" v-bind="attrs" v-on="on">
                  <v-icon small color="warning">mdi-alert</v-icon>
                  <span class="caption ml-1">{{ item.num_alertas | parseNumberToIntegerBR }}</span>
                </span>
              </template>
              <span>{{ item.num_alertas | parseNumberToIntegerBR }} alerta(s)</span>
            </v-tooltip>
          </span>
          <span v-else>-</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-saneamento"
            :class="item.status !== 'SUCESSO' ? 'cursor-block' : ''"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            :disabled="item.status !== 'SUCESSO'"
            @click="downloadPacote(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-btn id="action-arquivos-saneamento" min-width="0" class="px-1" fab icon x-small @click="openDialogArquivos(item)">
            <v-icon small>mdi-file-cloud-outline</v-icon>
          </v-btn>
          <v-btn
            id="action-painel-gerencial-saneamento"
            :class="item.status !== 'SUCESSO' ? 'cursor-block' : ''"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :disabled="item.status !== 'SUCESSO'"
            @click="abrirPainelGerencial(item)"
          >
            <v-icon small>mdi-chart-box</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="duplicarItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-content-copy</v-icon>
                  Duplicar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-title>
                  <v-icon small>mdi-file-find-outline</v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadLogsTecnicos(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-file-download-outline</v-icon>
                  Download logs
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogCreationLog(item)">
                <v-list-item-title>
                  <v-icon small>mdi-account-outline</v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('rechargeTable')">mdi-refresh</v-icon>
            </template>
            <span>Clique aqui para recarregar a lista</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-detalhes title="Detalhes do Saneamento" :show-dialog="dialogDetalhes" @changeValue="dialogDetalhes = $event">
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          :mobile-breakpoint="0"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
        >
          <template v-slot:item="row">
            <tr>
              <td class="button">
                {{ row.item.parametro }}
              </td>
              <td v-if="row.item.parametro === 'Status'" class="button">
                <general-status :status="row.item.valor" />
              </td>
              <td v-else class="button">
                {{ row.item.valor }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </dialog-detalhes>
    <dialog-detalhes
      title="Arquivos de Insumo"
      :show-dialog="dialogArquivos"
      max-width="800px"
      @changeValue="dialogArquivos = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogArquivosHeader"
          :items="dialogArquivosData"
          :loading="dialogArquivosDataLoading"
          :mobile-breakpoint="0"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
        >
          <template v-slot:item="row">
            <tr>
              <td class="button">
                {{ row.item.id }}
              </td>
              <td class="button" style="max-width: 0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="text-truncate" v-bind="attrs" v-on="on">
                      {{ row.item.nome }}
                    </div>
                  </template>
                  <span>{{ row.item.nome }}</span>
                </v-tooltip>
              </td>
              <td class="button" style="white-space: nowrap">
                {{ row.item.criado | parseToDateTimeBR }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </dialog-detalhes>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">
        Deletar Saneamento do Razão
        <span style="white-space: nowrap">#{{ dialogDeleteData.id }}</span>
      </template>
      <template slot="body">
        Tem certeza que deseja deletar o Saneamento do Razão
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>
  </v-container>
</template>

<script>
  import SaneamentosRazaoService from '@/services/SaneamentosRazaoService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    components: {
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      DialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
      DialogDelete: () => import('@/components/general/DialogDelete')
    },

    mixins: [powerupsActionsMixins, dateFormatterMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        required: true
      }
    },

    emits: ['switchProcessamentosExpirados', 'rechargeTable'],

    data: () => ({
      powerupService: SaneamentosRazaoService,
      powerupEntityName: 'Saneamento do Razão',
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Versão',
          value: 'sort_versao'
        },
        {
          text: 'Executado',
          value: 'finished_at'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Problemas',
          value: 'problemas'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      dialogDetalhesHeader: [
        { text: 'Parâmetro', value: 'parametro', sortable: false },
        { text: 'Valor', value: 'valor', sortable: false }
      ],
      dialogArquivos: false,
      dialogArquivosHeader: [
        { text: 'ID', value: 'id', sortable: true, width: '60px' },
        { text: 'Nome', value: 'nome', sortable: true },
        { text: 'Criado em', value: 'criado', sortable: true, width: '160px' }
      ],
      dialogArquivosData: [],
      dialogArquivosDataLoading: false
    }),

    methods: {
      novos() {
        SaneamentosRazaoService.novos()
          .then((res) => {
            this.$toast.success(res.data.message, '', { position: 'topRight' });
            this.$emit('rechargeTable');
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao disparar monitoramento de novos arquivos.', '', {
              position: 'topRight'
            });
          });
      },

      downloadPacote(item) {
        this.$toast.info('Preparando o pacote ZIP para download.', '', {
          position: 'topRight'
        });
        SaneamentosRazaoService.baixarArquivos(item.id, {
          timeout: 60 * 60 * 1000,
          onDownloadProgress: (progressEvent) => {
            let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            let isComputable = progressEvent.lengthComputable;

            this.$set(this.downloadProgressData, item.id, {
              progress,
              isComputable,
              id: item.id
            });
          }
        })
          .then((res) => {
            const nomeArquivo = item.nome.replace(/\s+/g, '_') + `_${item.id}.zip`;
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeArquivo);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Falha ao baixar pacote ZIP com resultado.', '', {
              position: 'topRight'
            });
          })
          .finally(() => {
            this.$delete(this.downloadProgressData, item.id);
          });
      },

      openDialogDetalhes(item) {
        this.dialogDetalhesData = [
          {
            parametro: 'ID',
            valor: item.id
          },
          {
            parametro: 'Nome',
            valor: item.nome
          },
          {
            parametro: 'Versão',
            valor: `${item.mes.toString().padStart(2, '0')}/${item.ano.toString().padStart(4, '0')} (${item.versao})`
          },
          {
            parametro: 'Iniciado em',
            valor: this.formatDateHour(item.started_at)
          },
          {
            parametro: 'Finalizado em',
            valor: this.formatDateHour(item.finished_at)
          },
          {
            parametro: 'Executado por',
            valor: item.executor?.nome ?? 'HEXA'
          },
          {
            parametro: 'Criado por',
            valor: item.usuario?.nome ?? 'HEXA'
          },
          {
            parametro: 'Criado em',
            valor: this.formatDateHour(item.created)
          },
          {
            parametro: 'Status',
            valor: item.status
          }
        ];

        if (['FALHA', 'SUCESSO'].includes(item.status)) {
          this.dialogDetalhesData.push(
            {
              parametro: 'Nº total de linhas',
              valor: item.num_total
            },
            {
              parametro: 'Nº de linhas com alertas',
              valor: item.num_alertas
            },
            {
              parametro: 'Nº de linhas com erros',
              valor: item.num_erros
            }
          );
        }

        this.dialogDetalhes = true;
      },

      openDialogArquivos(item) {
        this.dialogArquivosDataLoading = true;
        this.dialogArquivosData = [];
        this.dialogArquivos = true;

        SaneamentosRazaoService.listarArquivos(item.id)
          .then((response) => {
            this.dialogArquivosData = response.data.data.map((arquivo) => ({
              id: arquivo.id,
              nome: arquivo.arquivo,
              criado: arquivo.created
            }));
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error(`Falha ao baixar lista de arquivos do Saneamento #${item.id}.`, '', {
              position: 'topRight'
            });
          })
          .finally(() => {
            this.dialogArquivosDataLoading = false;
          });
      },

      openDialogCreationLog(item) {
        this.dialogCreationLogData = {
          username: item.usuario?.nome ?? 'HEXA',
          created: item.created
        };
        this.dialogCreationLog = true;
      },

      abrirPainelGerencial(item) {
        this.$router.push(`/saneamento-razao/painel-gerencial/${item.id}`);
      }
    }
  };
</script>

<style>
  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>
